module.exports = __webpack_public_path__ + "img/horizontal_6_7_7042.7a1d8786.png";